import createReactComponent from '../createReactComponent';
export default createReactComponent('alert-square', 'IconAlertSquare', [
  [
    'path',
    {
      d: 'M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M12 8v4', key: 'svg-1' }],
  ['path', { d: 'M12 16h.01', key: 'svg-2' }],
]);
